module.exports = __webpack_public_path__ + "img/dw_7.5c55cfa2.png";